import { Box, Typography } from "@mui/material";
import moment from "moment-jalaali";
import { toBilionToman, toToman } from "../../utils/Utils";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";

const CardItem = (props) => {
  const { title, value, first } = props;
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        borderLeft: !first && ((theme) => `1px solid ${theme.palette.grey[6]}`),
      }}
    >
      <Typography variant="subtitle1" color="secondary.main">
        {title}
      </Typography>
      <Box mt={1}>{value}</Box>
    </Box>
  );
};

function FinancialAssetCard({ sx = [], ...props }) {
  const { financialAsset, onClick = () => {} } = props;

  return (
    <Box
      onClick={onClick}
      sx={[
        {
          position: "relative",
          mt: 1,
          width: "100%",
          p: "16px",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          border: (theme) => `1px solid ${theme.palette.grey[7]}`,
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      <Box sx={{ position: "absolute", top: 16, right: 16 }}>
        <KeyboardArrowLeftIcon sx={{ color: "primary.main", height: 20 }} />
      </Box>
      <Box sx={{ display: "flex", alignItems: "center" }}>
        <img width={36} height={36} src={financialAsset.iconPath} />
        <Box sx={{ display: "flex", flexDirection: "column", ml: 1 }}>
          <Typography variant="subtitle1" color="grey.4">
            صندوق سرمایه‌گذاری
          </Typography>
          <Typography variant="body1" color="grey.2">
            {financialAsset.name}
          </Typography>
        </Box>
      </Box>
      {[
        {
          title: "آخرین به‌روزرسانی",
          value: moment(financialAsset.lastUpdateDate).format("jYYYY/jMM/jDD"),
        },
        {
          title: "قیمت خرید (تومان)",
          value: toToman(financialAsset.issueAmount),
        },
        {
          title: "قیمت فروش (تومان)",
          value: toToman(financialAsset.revokeAmount),
        },
      ].map((item) => {
        return (
          <Box
            key={item.title}
            sx={{
              mt: 1,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body2" color="grey.3">
              {item.title}
            </Typography>
            <Typography variant="body2" color="grey.3">
              {item.value}
            </Typography>
          </Box>
        );
      })}
    </Box>
  );
}

export default FinancialAssetCard;
